/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage, defineMessages, useIntl } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import {useReportsService} from "../../../../services/reportsService";


/* Components */
import SelectBookingDates from "../../../selectBookingDates";
import UCButton from "../../../buttons";
import { ReactComponent as DownloadIcon } from "../../../../resources/images/download-02.svg";
import { useUserContext } from "../../../../contexts/userContext";

/* Styles */
import styles, {customSelectStyles}from "./styles.js"
import {colors} from "../../../../constants/colors";
import { useHotelReportsService } from '../../../../services/hotelReportsService';

const messages = defineMessages({
  yearToDateLabel: {
    id: "bookings.filters.yearToDate"
  },
  travelDateLabel: {
    id: "bookings.filters.allTime"
  },
  downloadTravelCSV: {
    id: "receipts.button"
  },
})


const HotelBookingReportsFilters = ({gridOptions, setGridOptions, enableDownloadButton}) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const intl = useIntl();

  const { handleReportHotelDownload } = useHotelReportsService();
  const [showBookingOverlay, setShowBookingOverlay] = useState(false)
  const [showTravelOverlay, setShowTrevelsOverlay] = useState(false)

  const handleDownload = () => {
    handleReportHotelDownload(gridOptions)
  }

  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;


  return (
    <div className={classes.filters}>
      <div className={classes.filterButtons}>
        <div className={classes.filterDates}>
          <div className={classes.filterText}>
            <p><FormattedMessage id="bookings.filters.bookingDate" /></p>
            <SelectBookingDates
              gridOptions={gridOptions}
              setGridOptions={setGridOptions}
              defaultText={intl.formatMessage(messages.yearToDateLabel)}
              defaultValue='yearToDate'
              id={"booked"}
              showOverlay={showBookingOverlay}
              setShowOverlay={setShowBookingOverlay}
            />
          </div>
          <div className={classes.filterText}>
            <p><FormattedMessage id="bookings.filters.travelDate" /></p>
            <SelectBookingDates
              gridOptions={gridOptions}
              setGridOptions={setGridOptions}
              defaultText={intl.formatMessage(messages.travelDateLabel)}
              defaultValue='allTime'
              id={"travel"}
              showOverlay={showTravelOverlay}
              setShowOverlay={setShowTrevelsOverlay}
            />
          </div>
        </div>
      </div>
      <div className={classes.buttonContainer}>
        <UCButton
          type="primary"
          className={classes.button}
          onClick={handleDownload}
          text={<FormattedMessage id="receipts.button" />}
          icon={<DownloadIcon />}
          disabled={!enableDownloadButton}
          loadingStateStyling={classes.downloadCsvLoadingState}
          ariaLabel={intl.formatMessage(messages.downloadTravelCSV)}
          tabIndex={0}
          spinner={{
            name: "hotelReportDownloadSpinner",
            size: 20,
          }}
        />
      </div>

    </div>
  )
}

export default HotelBookingReportsFilters;
